import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { WhyTDSPage } from './why-tds.page';

const routes: Routes = [
  {
    path: '',
    component: WhyTDSPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class WhyTDSPageRoutingModule {}
